import { Signal } from '@angular/core';
import { SyncStoreSaveData } from '../../storage/sync-store/update-data/sync-store-save-data';
import { SyncStoreUpdateAnimalWeighing } from '../../storage/sync-store/update-data/sync-store-update-animal-weighing';
import { addAllObjectsToStore } from '../store-add-all-objects.function';

export function persistAnimalWeighings(
  newData: SyncStoreSaveData<SyncStoreUpdateAnimalWeighing>,
  dataFromStore: Signal<SyncStoreSaveData<SyncStoreUpdateAnimalWeighing>[]>
) {
  const allUpdateWeighings = addAllObjectsToStore([newData], dataFromStore());
  const retStateSlice = {
    animalWeighings: allUpdateWeighings as SyncStoreSaveData<SyncStoreUpdateAnimalWeighing>[],
  };
  return retStateSlice;
}
